const config = {
    env: 'production',
    // apiUrl: "https://apib.bizcontrol.in/admin/admin/"

    apiUrl: "https://apib.bizcontrol.in/admin/"
}

export default config;  